import { useSelector } from 'react-redux';

import { UserModel } from 'store/models';
import { currentUserSelector, userSelector } from 'store/main';
import { RootState } from 'store/rootReducer';
import { authCurrentUserIdSelector } from '$store/auth';
import { isTesterId } from '$utils';

export const useCurrentUserInfo = (): UserModel => {
  /* @ts-ignore */
  return useSelector(currentUserSelector);
};

export const useCurrentUserId = (): number => {
  /* @ts-ignore */
  return useSelector(authCurrentUserIdSelector);
};

export const useCurrentUserIsTester = (): boolean => {
  const userId = useCurrentUserId();
  return isTesterId(userId || 0);
};

export const useUserInfo = (userId: number): UserModel => {
  const userInfo = useSelector((state: RootState) => userSelector(state, userId));
  return userInfo as UserModel;
};
